import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ExperienceShortNameFilterPipe } from './experience-short-name-filter.pipe';

@NgModule({
    declarations: [
        ExperienceShortNameFilterPipe
    ],
    exports: [
        ExperienceShortNameFilterPipe
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class ExperienceShortNameFilterModule {
}



// WEBPACK FOOTER //
// ./src/app/_pipes/experience-short-name-filter.module.ts